module.exports = __webpack_public_path__ + "static/Rental-9f9203f0ab51f9cb85c86085f656a338.svg";